import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { modalSelector } from 'store/common/modal/selectors';
import { hideAllModal } from 'store/common/modal/actions';

export function withModal(modalId) {
  return (WrappedComponent) => (hocProps) => {
    const dispatch = useDispatch();

    const modalIds = useSelector(modalSelector);

    const closeModalHandler = useCallback(() => {
      dispatch(hideAllModal());
    }, [dispatch]);

    return modalIds.includes(modalId) ?
        <WrappedComponent onHideAllModal={closeModalHandler} {...hocProps} />
      : null;
  };
}
